var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"head",class:{'is-group': _vm.isGroup}},[(_vm.isRBC)?_c('com-rbc'):_vm._e(),_c('com-search'),(_vm.isGroup)?_c('div',{staticClass:"head-content"},[_c('router-link',{staticClass:"head-back",attrs:{"to":_vm.backLink}},[_vm._v("< see all guidelines")])],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }